import { JustpayQrcodePaymentEndpoint } from "@/views/loyalty/shared/endpoint_services/justpay-qrpayment-endpoint-service"
export const PaygineOrderStateEnum = { expired: "EXPIRED", completed: "COMPLETED", registered: "REGISTERED" }

export class JustpayQrPaymentService {
    constructor () {
        this.justpayQrcodePaymentEndpoint = new JustpayQrcodePaymentEndpoint()
    }

    async checkBankState (orderId, sbpId, pointId) {
        await this.justpayQrcodePaymentEndpoint.checkBankState(orderId, sbpId, pointId)
    }

    // Create Paygine order
    async createBankOrder (guid, pointId) {
        return this.justpayQrcodePaymentEndpoint.createBankOrder(guid, pointId)
    }

    async getCheque (orderId) {
        return this.justpayQrcodePaymentEndpoint.getCheque(orderId)
    }

    async getOrderByNumber (orderNumber) {
        return this.justpayQrcodePaymentEndpoint.getOrderByNumber(orderNumber)
    }

    async getOrder (pointId) {
        return this.justpayQrcodePaymentEndpoint.getOrder(pointId)
    }

    async getQrcode (id) {
        return this.justpayQrcodePaymentEndpoint.getQrcode(id)
    }

    async reGetBankOrder (pointId) {
        return this.justpayQrcodePaymentEndpoint.reGetBankOrder(pointId)
    }

    async sendCheque (orderId, email) {
        return this.justpayQrcodePaymentEndpoint.sendCheque(orderId, email)
    }

    async setCancelState (orderId, sbpId, pointId) {
        await this.justpayQrcodePaymentEndpoint.setCancelState(orderId, sbpId, pointId)
    }
}
